import { render, staticRenderFns } from "./news_style_detail.vue?vue&type=template&id=73f7c086&"
import script from "./news_style_detail.vue?vue&type=script&lang=js&"
export * from "./news_style_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_style_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports